import { useCallback, useMemo } from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';
import { ResponseError } from '../../../errors';

interface IUseImageLoadingHandlersProps {
  domain: string;
  src: string;
}
/**
 * @description
 * Хук для получения хэндлеров для обработки загрузки изображений.
 */
export const useImageLoadingHandlers = ({ domain, src }: IUseImageLoadingHandlersProps) => {
  const { logger, telemetry, config } = useApplicationContext();

  const onLoad = useCallback(() => {
    telemetry.increment('recommendations.image-load.success');
  }, [telemetry]);

  const onError = useCallback(() => {
    telemetry.increment('recommendations.image-load.error');

    if (!config.get<boolean>('ImageRetryRequest.Enabled')) {
      return;
    }
    /**
     * @description
     * Делаем повторный HTTP-запрос, чтобы получить текст ошибки, если она стабильна.
     */
    fetch(src)
      .then(res => {
        if (!res.ok) {
          throw new ResponseError({
            domain,
            message: JSON.stringify(res),
            details: {
              src,
            },
          });
        }
      })
      .catch(error => {
        logger.error('Image load error', {
          error: JSON.stringify(error),
          domain,
          details: {
            src,
          },
        });
      });
  }, [config, domain, logger, src, telemetry]);

  return useMemo(
    () => ({
      onLoad,
      onError,
    }),
    [onLoad, onError],
  );
};
